class ComponentTabs extends HTMLElement {
    tabs = [];
    panels = [];
    hashable = false;
    connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')]
            .filter(tab => tab.closest('tabs-component') === this);
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')]
            .filter(panel => panel.closest('tabs-component') === this);
        this.tabs.forEach((tab) => {
            const key = tab.getAttribute('aria-controls');
            if (key === null)
                return;
            tab.addEventListener('click', () => {
                this.changeTab(key);
            });
        });
        this.hashable = this.hasAttribute('hashable');
        if (this.hashable && window.location.hash.includes('tab-')) {
            const key = (window.location.hash.match(/tab-([^&]+)/) ?? [])[1];
            if (key.length > 0) {
                this.changeTab(key);
            }
        }
    }
    setHash(key) {
        if (window.location.hash.includes('tab-')) {
            window.location.hash = window.location.hash.replace(/tab-([^&]+)/, `tab-${key}`);
        }
        else if (window.location.hash.length > 0) {
            window.location.hash += `&tab-${key}`;
        }
        else {
            window.location.hash = `tab-${key}`;
        }
        history.replaceState(null, '', location.href);
    }
    changeTab(key) {
        this.tabs.forEach((tab) => {
            tab.setAttribute('aria-selected', (tab.getAttribute('aria-controls') === key).toString());
        });
        this.panels.forEach((panel) => {
            panel.hidden = panel.id !== key;
        });
        if (this.hashable) {
            this.setHash(key);
        }
    }
}
customElements.define('tabs-component', ComponentTabs);
export {};
